import React from "react";
import { BRAND } from "@/lib/brand";

// Faint global watermark of the EFORY arrow mark (no company name), on every page.
export default function Watermark() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[1] overflow-hidden">
      <img
        src={BRAND.mark}
        alt=""
        className="absolute left-1/2 top-1/2 w-[70vw] max-w-[760px] -translate-x-1/2 -translate-y-1/2 opacity-[0.035] select-none"
      />
    </div>
  );
}
